module.exports = __webpack_public_path__ + "static/media/mode-29.4ab7f2b7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-29.svg
// module id = 984
// module chunks = 2